import styled, { css } from 'styled-components';

const Title = styled.div`
  ${({ theme }) => css`
    ${theme.fontFamily.mainFont.largeExtraBold};
    margin-top: ${theme.spaces.space_20};
    margin-left: ${theme.spaces.space_16};
    margin-bottom: ${theme.spaces.space_16};
    color: ${theme.colors.night_blue};
  `}
`;

export default Title;
